///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { EMPTY, merge, of } from 'rxjs';
import { debounceTime, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { secondaryMarketCpOrderTabContentPersistRequested } from 'state/secondaryMarket/cpOrder';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';

export function triggerAmendCpOrderTabContentPersistenceEpic(): EpicWithThunk {
  return (
    actions$,
    state$,
    {
      selectors: {
        fromSecondaryMarket: {
          cpOrder: {
            formInput: { getAmendCpOrderTabContentToPersist },
          },
        },
      },
      scheduler,
    },
  ) => {
    const newForm$ = actions$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketPostEvents' && tabType === 'closePriceOrder'),
      map(({ id }) => id),
    );
    const modifyForm$ = actions$.pipe(
      ofType('SECONDARY_MARKET_CP_ORDER_FORM_FIELD_CHANGED'),
      debounceTime(3_000, scheduler),
      withLatestFrom(state$),
      filter(([{ tabId }, state]) => getWorkspaceType(state, tabId) === 'secondaryMarketPostEvents'),
      map(([{ tabId }, _]) => tabId),
    );
    return merge(modifyForm$, newForm$).pipe(
      withLatestFrom(state$),
      mergeMap(([tabId, state]) => {
        const persistedTabContent = getAmendCpOrderTabContentToPersist(state, tabId);

        if (persistedTabContent === undefined) {
          return EMPTY;
        }
        return of(
          secondaryMarketCpOrderTabContentPersistRequested(tabId, 'secondaryMarketPostEvents', persistedTabContent),
        );
      }),
    );
  };
}
